import { supabase } from './supabase/client';
import { CreateClassDTO, UpdateClassDTO, ClassFilters, ClassListResponse } from 'src/types/class.types';

const TABLE_NAME = 'classes';

/**
 * Service for managing class
 */
export const classService = {
  /**
   * Get classes with filters and pagination
   */

  // /**
  //  * Get a single student behaviour by ID
  //  */
  // async getStudentBehaviourById(id: string): Promise<StudentBehaviour | null> {
  //   try {
  //     const { data, error } = await supabase
  //       .from(TABLE_NAME)
  //       .select(
  //         `
  //         *,
  //         behaviour_types (
  //           title,
  //           type,
  //           points
  //         ),
  //         student: students (
  //           *,
  //           user: users (
  //             firstname,
  //             lastname,
  //             email
  //           )
  //         )
  //       `
  //       )
  //       .eq('id', id)
  //       .single();

  //     if (error) throw error;
  //     return data as StudentBehaviour;
  //   } catch (error) {
  //     console.error('[StudentBehaviourService.getStudentBehaviourById]:', error);
  //     throw error;
  //   }
  // },

  // /**
  //  * Create a new student behaviour
  //  */
  // async createStudentBehaviour(dto: CreateStudentBehaviourDTO): Promise<StudentBehaviour> {
  //   try {
  //     if (!dto.points) {
  //       const { data: behaviourType } = await supabase
  //         .from('behaviour_types')
  //         .select('points')
  //         .eq('id', dto.behaviourTypeId)
  //         .single();

  //       dto.points = behaviourType?.points || 0;
  //     }

  //     const { data, error } = await supabase
  //       .from(TABLE_NAME)
  //       .insert([
  //         {
  //           ...dto,
  //           extendedProperties: dto.extendedProperties ?? {},
  //         },
  //       ])
  //       .select()
  //       .single();

  //     if (error) throw error;
  //     return data as StudentBehaviour;
  //   } catch (error) {
  //     console.error('[StudentBehaviourService.createStudentBehaviour]:', error);
  //     throw error;
  //   }
  // },

  // /**
  //  * Update a student behaviour
  //  */
  // async updateStudentBehaviour(id: string, dto: UpdateStudentBehaviourDTO): Promise<StudentBehaviour> {
  //   try {
  //     const { data, error } = await supabase.from(TABLE_NAME).update(dto).eq('id', id).select().single();

  //     if (error) throw error;
  //     return data as StudentBehaviour;
  //   } catch (error) {
  //     console.error('[StudentBehaviourService.updateStudentBehaviour]:', error);
  //     throw error;
  //   }
  // },

  // /**
  //  * Delete a student behaviour
  //  */
  // async deleteStudentBehaviour(id: string): Promise<void> {
  //   try {
  //     const { error } = await supabase.from(TABLE_NAME).update({ deletedAt: new Date().toISOString() }).eq('id', id);

  //     if (error) throw error;
  //   } catch (error) {
  //     console.error('[StudentBehaviourService.deleteStudentBehaviour]:', error);
  //     throw error;
  //   }
  // },

  // async getPlatformBehaviorCount(): Promise<{ positive: number; negative: number }> {
  //   try {
  //     const {
  //       data,
  //       count: positiveCount,
  //       error: positiveError,
  //     } = await supabase.rpc('get_behavior_counts', { student_id: null });

  //
  //     return data as { positive: number; negative: number };
  //   } catch (error) {
  //     console.error('[StudentService.getStudentBehaviorCount]:', error);
  //     throw error;
  //   }
  // },

  // Define the DTO for creating a class

  // Create a new class or Grade level
  async createClass(dto: { title: string; startTime?: string; endTime?: string; teacherid?: string }): Promise<any> {
    try {
      const { data, error } = await supabase
        .from(TABLE_NAME)
        .insert({
          name: dto.title,
          starttime: dto.startTime || '08:00',
          endtime: dto.endTime || '15:00',
          teacherid: dto.teacherid || null,
        })
        .select()
        .single();
      if (error) throw error;
      return data;
    } catch (error) {
      console.error('[classService.createClass]:', error);
      throw error;
    }
  },

  /**
   * Update / Rename a class or grade level
   */
  async updateClass(
    id: string,
    dto: { name?: string; title?: string; startTime?: string; endTime?: string; teacherid?: string }
  ): Promise<any> {
    try {
      const updatePayload: Record<string, any> = {};
      if (dto.name !== undefined) updatePayload.name = dto.name;
      else if (dto.title !== undefined) updatePayload.name = dto.title;
      if (dto.startTime !== undefined) updatePayload.starttime = dto.startTime;
      if (dto.endTime !== undefined) updatePayload.endtime = dto.endTime;
      if (dto.teacherid !== undefined) updatePayload.teacherid = dto.teacherid;

      const { data, error } = await supabase
        .from(TABLE_NAME)
        .update(updatePayload)
        .eq('id', id)
        .select()
        .single();

      if (error) throw new Error(error.message);
      return data;
    } catch (error) {
      console.error('[classService.updateClass]:', error);
      throw error;
    }
  },

  /**
   * Delete a class or grade level with strict safety check for active cohorts
   */
  async deleteClass(id: string): Promise<void> {
    try {
      // 1. Check if active cohorts exist for this class
      const { data: activeCohorts, error: cohortCheckError } = await supabase
        .from('cohorts')
        .select('id, name')
        .eq('class_id', id);

      if (cohortCheckError) {
        console.error('[classService.deleteClass check error]:', cohortCheckError);
      }

      if (activeCohorts && activeCohorts.length > 0) {
        const cohortNames = activeCohorts.map((c) => c.name).join(', ');
        throw new Error(
          `Cannot delete class: ${activeCohorts.length} active cohort(s) (${cohortNames}) are currently assigned. Please delete or reassign all cohorts first.`
        );
      }

      // 2. Clear student class enrollments
      await supabase.from('studentclassenrollments').delete().eq('classid', id);

      // 3. Delete class record
      const { error } = await supabase.from(TABLE_NAME).delete().eq('id', id);
      if (error) throw new Error(error.message);
    } catch (error) {
      console.error('[classService.deleteClass]:', error);
      throw error;
    }
  },

  // async getClasses({ search, page = 1, limit = 100 }: ClassFilters = {}): Promise<ClassListResponse> {
  //   try {
  //     let query = supabase.from(TABLE_NAME).select('*', { count: 'exact' });

  //     if (search) {
  //       query = query.or(`name.ilike.%${search}%,description.ilike.%${search}%`);
  //     }

  //     // Add pagination
  //     const from = (page - 1) * limit;
  //     const to = from + limit - 1;
  //     query = query.range(from, to).order('createdat', { ascending: false });

  //     const { data, error, count } = await query;

  //     if (error) throw error;

  //     return {
  //       data: data as Class[],
  //       total: count || 0,
  //       page,
  //       limit,
  //     };
  //   } catch (error) {
  //     console.error('[ClassService.getClasses]:', error);
  //     throw error;
  //   }
  // },

  /**
   * Get classes with the number of enrolled students
   */
  // async getClasses({ search, page = 1, limit = 100 }: ClassFilters = {}): Promise<ClassListResponse> {
  //   try {
  //     const { data, error } = await supabase
  //       .from('classes')
  //       .select(
  //         `*,
  //         studentclassenrollments:studentclassenrollments(classid, studentid, students(*))
  //       `
  //       )
  //       .ilike('name', `%${search}%`)
  //       .range((page - 1) * limit, page * limit - 1);
  //

  //     if (error) throw error;

  //     // Map through classes and add the number of enrolled students
  //     const classesWithEnrollment = data.map((classItem: any) => ({
  //       ...classItem,
  //       enrolledStudents: classItem.studentclassenrollments.map((enrollment: any) => ({
  //         studentId: enrollment.studentid,
  //         ...enrollment.students, // Add student details here
  //       })),
  //     }));

  //     return { data: classesWithEnrollment, page, limit };
  //   } catch (error) {
  //     console.error('[classService.getClassesWithEnrolledStudents]:', error);
  //     throw error;
  //   }
  // },
  async getClasses({ teacherUserId }: ClassFilters = {}): Promise<ClassListResponse> {
    try {
      // Query classes and include enrolled students (using LEFT JOINs so empty classes are included)
      let query = supabase.from('classes').select(`
          *,
          teachers(
            id,
            userid
          ),
          studentclassenrollments(
            studentid,
            students(
              id,
              grade,
              balance,
              userid,
              user:users(
                id,
                firstname,
                lastname,
                email,
                role,
                extendedproperties
              ),
              badge:badges(*)
            )
          )
        `).order('createdat', { ascending: false });

      if (teacherUserId) {
        query = query.eq('teachers.userid', teacherUserId);
      }

      const { data, error } = await query;
      if (error) throw error;

      // Process the data to include enrolled student details safely
      const processedData = data?.map((classData) => ({
        ...classData,
        enrolledStudents: (classData.studentclassenrollments || [])
          .filter((enrollment: any) => enrollment && enrollment.students)
          .map((enrollment: any) => ({
            studentId: enrollment.studentid,
            ...enrollment.students,
            user: {
              ...enrollment.students?.user,
              extendedProperties: enrollment.students?.user?.extendedproperties || {},
            },
            badge: enrollment.students?.badge,
          })),
      }));

      return {
        data: processedData || [],
      };
    } catch (error) {
      console.error('[classService.getClassesWithEnrolledStudents]:', error);
      throw error;
    }
  },
  /**
   * Enroll a student in a class
   */
  async enrollStudentInClass(studentId: string, classId: string): Promise<void> {
    try {
      const { error } = await supabase
        .from('studentclassenrollments')
        .insert({ studentid: studentId, classid: classId });

      if (error) throw error;
    } catch (error) {
      console.error('[classService.enrollStudentInClass]:', error);
      throw error;
    }
  },

  /**
   * Enroll multiple students in a class, avoiding duplicates
   */
  async enrollStudentsInClass(studentIds: string[], classId: string): Promise<void> {
    try {
      // Fetch existing enrollments
      const { data: existingEnrollments, error: fetchError } = await supabase
        .from('studentclassenrollments')
        .select('studentid')
        .eq('classid', classId)
        .in('studentid', studentIds);

      if (fetchError) throw fetchError;

      // Filter out students already enrolled
      const existingStudentIds = new Set(existingEnrollments.map((enrollment) => enrollment.studentid));
      const newStudentIds = studentIds.filter((id) => !existingStudentIds.has(id));

      if (newStudentIds.length > 0) {
        const { error: insertError } = await supabase
          .from('studentclassenrollments')
          .insert(newStudentIds.map((studentId) => ({ studentid: studentId, classid: classId })));

        if (insertError) throw insertError;
      }
    } catch (error) {
      console.error('[classService.enrollStudentsInClass]:', error);
      throw error;
    }
  },
  /**
   * Unenroll students from a class
   */
  async unenrollStudentsFromClass(studentIds: string[], classId: string): Promise<void> {
    try {
      const { error } = await supabase
        .from('studentclassenrollments')
        .delete()
        .eq('classid', classId)
        .in('studentid', studentIds);

      if (error) throw error;
    } catch (error) {
      console.error('[classService.unenrollStudentsFromClass]:', error);
      throw error;
    }
  },
};
